import React from "react";
import { Outlet, Link } from "react-router-dom";
import {Header} from "./header/navmenu";
import {Footer} from "./footer/footer";
import "./Layout.scss";

const Layout = () => {
  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        <Outlet /> {/* Здесь будут отображаться страницы */}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
